import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelpersService {

  addOrReplaceString(array: string[], item: string): void { // (1)
    const i = array.findIndex(_item => _item == item);
    if (i > -1) array[i] = item; // (2)
    else array.push(item);
  }
  
  generateRandomString(length: number): string {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;

    for ( var i = 0; i < length; i++ ) {
        result += characters?.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  // Compares objects in the array by compare key and adds a 'item' object if not exist in the array
  addOrReplace(array: {}[], item: {}, compareKey: string): void { // (1)
    const i = array.findIndex(_item => _item[compareKey] == item[compareKey]);
    if (i > -1) array[i] = item; // (2)
    else array.push(item);
  }

  // Used as argument in array.sort() method
  sortObjectsAscending(byKey: string): any {
    return (a, b) => {
      if ( a[byKey] < b[byKey] ) return -1;
      if ( a[byKey] > b[byKey] ) return 1;
      return 0;
    };
  }

  // Used as argument in array.sort() method
  sortObjectsDescending(byKey: string): any {
    return (a, b) => {
      if ( a[byKey] < b[byKey] ) return 1;
      if ( a[byKey] > b[byKey] ) return -1;
      return 0;
    };
  }

  // Checks if object is empty (no properties and values)
  isEmpty(obj: object): boolean {
    for(var key in obj) {
      if(obj.hasOwnProperty(key))
      return false;
    }
    return true;
  }

  arrayFromObject(obj: object): any[] {
    let arr = [];

    for(let i in obj) {
      arr.push([i, obj[i]]);
    }
    return arr;
  }

  fileSizeOK(size, maxSize?): boolean {
    var sizelimitmin =  0;
    var sizelimitmax = maxSize ?? 15728640;

    if (size > sizelimitmax || size < sizelimitmin) {
      return false;
    } else {
      return true;
    }
  }
  
  dateinTZ(date, ianatz) {
    var invdate = new Date(date.toLocaleString('en-US', {
      timeZone: ianatz
    }));
    return invdate;
  }
}
